var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBigStickFigure = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 42,
    viewBox: "0 0 21 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1077 -961) translate(1079 963)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.212,
    cy: 6.909,
    r: 6.909
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M9.212 13.818v15.808"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 29.939L8.636 38 17.273 29.939",
    transform: "rotate(180 8.636 33.97)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 16.121L8.636 24.182 17.273 16.121"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBigStickFigure, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BigStickFigure.d19af3c8.svg";
export { ForwardRef as ReactComponent };